import axios from "axios";

export const geoService = {
  async suggestDadataAddress(payload) {
    const token = "c4a91b35d3d80df92c11f9038543fb030e20c548";
    return axios({
      method: "post",
      url: "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Token " + token,
      },
      data: {
        query: payload.query,
        to_bound: payload.param.to_bound,
        from_bound: payload.param.from_bound,
        locations: payload.param.locations,
      },
    });
  },

  async getNearestCoordinates(address) {
    try {
      const { data } = await axios({
        method: "get",
        url: `/1.x`,
        baseURL: "https://geocode-maps.yandex.ru",
        params: {
          geocode: address,
          apikey: process.env.VUE_APP_MAP_API_KEY,
          format: "json",
        },
      });

      const featureMember = data.response?.GeoObjectCollection?.featureMember;
      if (featureMember?.length) {
        const withCoords = featureMember.find(
          (item) => !!item?.GeoObject?.Point?.pos
        );
        if (withCoords?.GeoObject?.Point?.pos) {
          const coords = withCoords.GeoObject.Point.pos.split(" ");
          const lat = coords[1];
          const lon = coords[0];
          if (!lat || !lon) {
            return null;
          }
          return {
            lat: withCoords.GeoObject.Point.pos.split(" ")[1],
            lon: withCoords.GeoObject.Point.pos.split(" ")[0],
          };
        }
      }
      return null;
    } catch (error) {
      console.log(error);
      return null;
    }
  },
};
